/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.staff.controllers', [])

.controller('ResourcesStaffController', ['$scope', function($scope) {

    $scope.resourcesStaff = {
      init: function() {

      },

      invite: function () {
        $scope.$emit('AppController::users::invite');
      }
    };

    $scope.resourcesStaff.init();

}]);